<template>
    <div
      :class="['live_item', {isDetail: applicationPage == 'detail'}]"
      :style="{
        'background-color': bgColor,
      }"
    >
      <!-- 专辑  -->
      <div v-if="msg.menus.length && msg.menus[0].title">
        <div class="video_special" @click.stop.prevent="handleClickVideoDetail">
          <div class="video_cover">
            <img v-lazy="msg.menus[0].v_cover || msg.menus[0].v_img" alt />
            <div class="play_btn">
              <img :src="require('@/assets/images/icon-play-btn@2x.png')" alt />
            </div>
          </div>
          <div class="video_special_detail">
            <div>
              <h4>{{msg.menus[0].title}}</h4>
              <p>{{msg.menus[0].video_desc}}</p>
            </div>
            <dl>
              <dt>
                <img :src="require('@/assets/images/icon-video @2x.png')" alt />
              </dt>
              <dd>查看视频</dd>
            </dl>
          </div>
        </div>
      </div>
      
      <div v-else>
        <div class="thumbnail">
          <template v-for="(imgVideoItem, i) in imgVideoList">
            <!-- 视频 -->
            <div
              v-if="imgVideoItem.type === 'video'"
              ref="imgItem"
              :isrc="imgVideoItem.video_cover_url"
              class="img-item img-video"
              :class="{'img-item-one':msg.image.length==0}"
              :key="randomStr + i"
              @click.stop.prevent="()=>srBrowserMedia(i)"
            >
              <div class="vedio_img" v-if="imgVideoItem.video_cover_url">
                <span class="vedio_image">
                  <img class="vedio_image_img" :src="imgVideoItem.video_cover_url" alt />
                  <!-- todo -->
                  <p>
                    <img
                      class="vedio_play"
                      src="https://cdn.aigupiao.com/static/wrap/img/media_play_ico.png"
                    />
                    <span class="vedio_time">
                      <img
                        class="vedio_time_icon"
                        src="https://cdn.aigupiao.com/static/wrap/img/small_video_ico1.png"
                      />
                      <i>{{imgVideoItem.video_len}}s</i>
                    </span>
                  </p>
                </span>
              </div>
            </div>

            <!-- 图片 -->
            <div
              v-if="imgVideoItem.type === 'image'"
              ref="imgItem"
              :isrc="imgVideoItem.img_url"
              class="img-item"
              :class="{
                'img-item-one': msg.image.length==1 && (!msg.menus || msg.menus.length==0),
                'img-item-is_hide': (i > 2 && applicationPage != 'detail'),
              }"
              :key="'index'+i"
              @click.stop.prevent="()=>srBrowserMedia(i)"
            >
              <img class="live_img" v-lazy="imgVideoItem.img_url" alt="图片" />
              <span
                class="image_c"
                v-if="(i == 2 && applicationPage != 'detail' && imgVideoList.length > 3)"
              >{{msg.image.length}}图</span>
              <!-- @click.stop.prevent="goDetail" -->
            </div>
          </template>
        </div>
      </div>
    </div>
  </template>
<script>
  export default {
    name: "imageViewpoint",
    props: {
      msg: Object,
      bgColor: {
        type: String,
        default: "#FFF"
      },
      applicationPage: { // 来源使用页面 - 列表或者详情页【list,detail】
          type: String,
          default: "list"
      },
    },
    data() {
      return {
        randomStr: Math.random()
          .toString(36)
          .slice(-4),
      };
    },
    computed: {
      imgVideoList: function () {
        let imgVideoList = [];
        let msg = this.msg;
        msg.menus.forEach((element) => {
          imgVideoList.push({
            type: "video",
            video_url: element.video,
            video_cover_url: element.video_img,
            video_len: element.video_len,
          });
        });
        msg.image.forEach((element) => {
          imgVideoList.push({
            type: "image",
            img_url: element,
          });
        });
        
        return imgVideoList;
      },
    },
    created() {
      
    },
    mounted() {
      // 简单有效，不用搞太复杂
      this.$nextTick(() => {
        this.setImageStyles();
      });
      setTimeout(() => {
        this.$nextTick(() => {
          this.setImageStyles(); // 直接调用，简单粗暴
        });
      }, 300);
    },
    methods: {
      setImageStyles(){
        // 设置缩略图的样式。
        if (this.$refs.imgItem && this.$refs.imgItem.length > 0) {
        this.$refs.imgItem.forEach((element) => {
          let eWidth = element.offsetWidth;
          let live_img = element.querySelectorAll("img.live_img,img.vedio_image_img")[0];
          let isOneImg = element.classList.contains("img-item-one"); //是否是单独的
          let isrc = element.getAttribute("isrc");
          element.style.height = eWidth + "px";
          let _img = new Image();
          _img.onload = function () {
            let maxHeight = (eWidth * 5) / 3;
            let maxWidth = (eWidth * 5) / 3;
            let oneMaxHeight = (maxHeight * 3) / 4;
            let tempWidth = 0;
            let tempHeight = 0;
            if (!isOneImg) {
              if (_img.width / _img.height >= 1) {
                //横向图
                live_img.classList.add("widthlong");
              } else {
                //竖向图
                live_img.classList.add("heightlong");
              }
            } else {
              if (_img.width / _img.height >= 1) {
                //横向图
                var o_height = Math.ceil(
                  _img.height / (_img.width / maxWidth)
                );
                o_height =
                    o_height > oneMaxHeight
                        ? o_height
                        : oneMaxHeight;
                tempWidth = maxWidth;
                tempHeight = o_height;
                live_img.classList.add("widthlong");
              } else {
                //竖向图
                var o_width = Math.ceil(
                  _img.width / (_img.height / maxHeight)
                );
                o_width =
                    o_width > oneMaxHeight
                        ? o_width
                        : oneMaxHeight;
                tempHeight = maxHeight;
                tempWidth = o_width;
                live_img.classList.add("heightlong");
              }
              element.style.cssText = `width:${tempWidth}px;height:${tempHeight}px;`;
            }
          };
          _img.src = isrc;
        });
        }
      },
      clickPlay(src) {
        this.$videoplay.open(src);
      },
      srBrowserMedia(index) {
        if(this.kind == 'preview') return false;
        let mediaUrlList = this.imgVideoList;
        console.info("HANDLECLICKE")
        this.$srBrowserMedia(index, mediaUrlList);
      },
      handleClickVideoDetail() {
          this.openNative("video_page", {
            id: this.msg.menus[0].id
          });
      },
      // 跳转APP页面
      openNative(type, query = {}) {
          let params = {
              kind: type, // 类型
          };

          // 同步传参
          params = {
            ...params,
            ...query
          }

          switch (type) {
              case "video_page": // 专辑详情页
                  break;
          }

          this.$srH5CallNativeMethodApp('call_Native', params)
      },
    }
  };
  </script>
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.live_item .thumbnail .img-item-one {
  width: 231px !important;
  height: 174px !important;
}

.live_item {
  padding: 0 10px;
  box-sizing: border-box;

  &.isDetail {
    padding: 0;
  }
}

.img_box {
  padding-top: 10px;
}

//图片样式
.thumbnail {
  display: flex;
  flex-wrap: wrap;

  .img-item {
    position: relative;
    overflow: hidden;
    width: 33.33%;
    padding: 0px;
    border: 3px solid transparent;
    box-sizing: border-box;
    margin: 0;
    min-height: 100px;

    &.img-item-is_hide {
      width: 0;
      height: 0;
      overflow: hidden;
      visibility: hidden;
    }

    .heightlong {
      position: absolute;
      width: 100%;
      height: auto;
      top: 50%;
      transform: translateY(-50%);
    }

    .widthlong {
      position: absolute;
      height: 100%;
      width: auto;
      left: 50%;
      transform: translateX(-50%);
    }

    .paly_video {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: -15px;
      margin-left: -15px;
      display: flex;
      width: 30px;
      height: 30px;
      overflow: hidden;
      border-radius: 50%;
      border: 2px solid #ffffff;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.15);

      >.icon {
        font-size: 13px;
        margin-left: 3px;
      }
    }

    .video_len {
      position: absolute;
      display: flex;
      align-items: center;
      height: 19px;
      padding: 0 5px;
      right: 0;
      bottom: 0;
      border-radius: 5px 0 0 0;
      background: rgba(0, 0, 0, 0.55);
      font-size: 11px;
      color: #fefffe;

      >.icon {
        font-size: 12px;
        margin-right: 4px;
      }
    }

    .image_c {
      list-style: none;
      word-break: break-all;
      word-wrap: break-word;
      margin: 0;
      padding: 0;
      border: 0;
      outline: 0;
      vertical-align: baseline;
      background: transparent;
      display: inline-block;
      position: absolute;
      z-index: 0;
      width: 35px;
      height: 22px;
      background-color: rgba(119, 115, 115, 0.8);
      border-bottom-left-radius: 6px;
      right: 0px;
      color: rgb(254, 255, 254);
      text-align: center;
      user-select: none;
      cursor: pointer;
      font-size: 12px;
      line-height: 22px;
    }
  }

  >div {
    height: 111px;
    width: 111px;

    >img {
      width: 100%;
      height: 100%;
    }
  }
}

//视频专辑样式
.video_special {
  padding: 6px 4px 0;

  .video_cover {
    height: 198px;
    position: relative;

    >img {
      width: 100%;
      height: 100%;
    }

    .play_btn {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -23px;
      margin-left: -23px;
      width: 47px;
      height: 47px;

      >img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .video_special_detail {
    display: flex;
    box-sizing: content-box;
    height: 60px;
    justify-content: space-between;
    padding: 0 10px;
    background: #f5f6f7;

    >div {
      height: 100%;
      display: flex;
      flex-direction: column;

      >h4 {
        height: 17px;
        font-size: 15px;
        color: #222222;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 400;
        margin: 10px 0 8px 0;
        line-height: 17px;
      }

      >p {
        font-size: 14px;
        // color:@color-gray-middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #636363;
        font-size: 13px;
      }
    }

    >dl {
      flex-shrink: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      // justify-content: space-around;
      align-items: center;

      >dt {
        width: 27px;
        height: 22px;
        margin: 9px 0 6px 0;

        >img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      >dd {
        font-size: 14px;
        color: #fe696b;
      }
    }
  }
}

.vedio_img {
  height: 100%;

  .vedio_image {
    display: block;
    height: 100%;
    position: relative;

    >img {
      height: 100%;
      width: 100%;
    }

    p {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;

      .vedio_time {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 70px !important;
        height: 23px !important;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .vedio_time_icon {
          line-height: 23px;
          width: 14px !important;
          height: 14px !important;
          margin-left: 7px;
        }

        >i {
          color: #fff;
          font-size: 14px !important;
          line-height: 23px !important;
          padding-left: 10px;
          font-style: normal;
          white-space: nowrap;
        }
      }
    }
  }
}

.vedio_play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px !important;
  height: 30px !important;
}
</style>